import { Directive, DirectiveBinding } from 'vue';
import { useV6Permission } from '@/composables/useV6Permission';

/**
 * v-permission 指令
 * 用法: v-permission="'*:platform_analyst:template:generate'"
 * 如果当前用户无该权限，则元素会被隐藏 (display: none)
 */
const permissionDirective: Directive<HTMLElement, string> = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    const { hasPermission } = useV6Permission();
    const requiredPermission = binding.value;
    if (!requiredPermission) return;

    // 检查权限
    if (!hasPermission(requiredPermission)) {
      el.style.display = 'none';
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding<string>) {
    const { hasPermission } = useV6Permission();
    const requiredPermission = binding.value;
    if (!requiredPermission) {
      el.style.display = '';
      return;
    }

    if (!hasPermission(requiredPermission)) {
      el.style.display = 'none';
    } else {
      el.style.display = '';
    }
  }
};

export default permissionDirective;